module.exports = __webpack_public_path__ + "static/media/badge-titan.a8aa2f67.png";